import { render, staticRenderFns } from "./FacturaLibre.vue?vue&type=template&id=7964731e&"
import script from "./FacturaLibre.vue?vue&type=script&lang=js&"
export * from "./FacturaLibre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports